import * as React from 'react';

function PlaceholderVinOnly(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -55 359.33 220">
			<defs>
				<style>
					{'.cls-1{fill: #005ca9;} .cls-2{fill: #fff;} .cls-3{fill: #ccdeed;} .cls-4{opacity: .7;}'}
				</style>
			</defs>
			<g id="Ebene_1" data-name="Ebene 1">
				<rect className="cls-3" width="359.33" height="110" />
			</g>
			<g id="Ebene_8" data-name="Ebene 8">
				<g className="cls-4">
					<rect className="cls-1" x="26" y="18" width="307" height="74" rx="37" ry="37" />
				</g>
				<g>
					<path
						className="cls-2"
						d="m80.25,45.95l-4.15,14.6c-.17.6-.75,1.03-1.4,1.03h-.02c-.65,0-1.17-.45-1.32-1.03l-3.42-12.57-3.45,12.57c-.17.6-.7,1.03-1.38,1.03h-.02c-.67,0-1.17-.43-1.32-1l-4.15-14.62c-.02-.1-.05-.2-.05-.3,0-.52.42-1.05,1.07-1.05.5,0,.97.32,1.1.82l3.52,13.22,3.65-13.27c.12-.45.52-.77,1.05-.77.47,0,.9.32,1.02.77l3.65,13.27,3.5-13.22c.12-.48.57-.8,1.07-.8.62,0,1.1.45,1.1,1.02,0,.1-.02.2-.05.3Z"
					/>
					<path
						className="cls-2"
						d="m88.63,61.72c-4.57,0-6.37-4.57-6.37-8.62s1.8-8.6,6.37-8.6,6.37,4.52,6.37,8.6-1.82,8.62-6.37,8.62Zm0-15.37c-3.17,0-4.25,3.42-4.25,6.75s1.08,6.77,4.25,6.77,4.25-3.45,4.25-6.77-1.07-6.75-4.25-6.75Z"
					/>
					<path
						className="cls-2"
						d="m107.3,61.42h-7.57c-.82,0-1.5-.67-1.5-1.5v-14.32c0-.55.45-1,1.07-1,.55,0,1,.45,1,1v13.97h7c.5,0,.9.4.9.9,0,.55-.4.95-.9.95Z"
					/>
					<path
						className="cls-2"
						d="m116.68,61.72c-4.57,0-6.37-4.57-6.37-8.62s1.8-8.6,6.37-8.6,6.37,4.52,6.37,8.6-1.82,8.62-6.37,8.62Zm0-15.37c-3.17,0-4.25,3.42-4.25,6.75s1.08,6.77,4.25,6.77,4.25-3.45,4.25-6.77-1.07-6.75-4.25-6.75Z"
					/>
					<path
						className="cls-2"
						d="m131.98,61.72c-4.57,0-6.37-4.57-6.37-8.62s1.8-8.6,6.37-8.6,6.37,4.52,6.37,8.6-1.82,8.62-6.37,8.62Zm0-15.37c-3.17,0-4.25,3.42-4.25,6.75s1.08,6.77,4.25,6.77,4.25-3.45,4.25-6.77-1.07-6.75-4.25-6.75Z"
					/>
					<path
						className="cls-2"
						d="m147.28,61.72c-4.57,0-6.37-4.57-6.37-8.62s1.8-8.6,6.37-8.6,6.37,4.52,6.37,8.6-1.82,8.62-6.37,8.62Zm0-15.37c-3.17,0-4.25,3.42-4.25,6.75s1.08,6.77,4.25,6.77,4.25-3.45,4.25-6.77-1.07-6.75-4.25-6.75Z"
					/>
					<path
						className="cls-2"
						d="m162.58,61.72c-4.57,0-6.37-4.57-6.37-8.62s1.8-8.6,6.37-8.6,6.37,4.52,6.37,8.6-1.82,8.62-6.37,8.62Zm0-15.37c-3.17,0-4.25,3.42-4.25,6.75s1.08,6.77,4.25,6.77,4.25-3.45,4.25-6.77-1.07-6.75-4.25-6.75Z"
					/>
					<path
						className="cls-2"
						d="m177.75,61.72c-2.42,0-4.12-.75-5.4-2.1-.17-.17-.25-.4-.25-.65,0-.43.35-.97.9-.97.23,0,.47.07.65.25,1.07,1.07,2.37,1.62,4.1,1.62,2.27,0,3.85-1.55,3.85-3.57,0-2.2-1.58-3.6-3.82-3.6-1.25,0-2.47.4-3.45,1.2-.25.2-.55.32-.85.32-.57,0-1.07-.42-1.07-1.02v-6.95c0-.82.67-1.5,1.5-1.5h7.95c.5,0,.9.4.9.95,0,.5-.4.9-.9.9h-7.37v5.8c.8-.8,2.22-1.5,3.9-1.5,2.77,0,5.3,1.9,5.3,5.32s-2.57,5.5-5.92,5.5Z"
					/>
					<path
						className="cls-2"
						d="m190.45,61.57c-.58,0-1.02-.45-1.02-1.03v-13.05l-2.2,2.32c-.17.17-.37.25-.6.25-.45,0-.9-.38-.9-.9,0-.23.08-.45.25-.62l3.52-3.6c.2-.22.5-.32.83-.32.62,0,1.17.48,1.17,1.12v14.8c0,.58-.45,1.03-1.05,1.03Z"
					/>
					<path
						className="cls-2"
						d="m206.15,46.6h-4.55v13.95c0,.58-.45,1.03-1.05,1.03s-1.03-.45-1.03-1.03v-13.95h-4.52c-.5,0-.9-.4-.9-.95,0-.5.4-.9.9-.9h11.15c.5,0,.9.4.9.95,0,.5-.4.9-.9.9Z"
					/>
					<path
						className="cls-2"
						d="m219.75,61.42h-9.97c-.47,0-.95-.42-.95-1,0-.3.12-.57.38-.77,5.85-4.52,9.1-7.45,9.1-10.25,0-2.12-1.75-3.05-3.47-3.05s-3.02.57-4.02,1.55c-.18.17-.4.25-.6.25-.47,0-.95-.4-.95-.92,0-.23.08-.48.25-.65,1.37-1.38,3.27-2.07,5.32-2.07,2.77,0,5.6,1.57,5.6,4.9s-3.45,6.5-8.1,10.17h7.42c.5,0,.9.4.9.9,0,.55-.4.95-.9.95Z"
					/>
					<path
						className="cls-2"
						d="m227.88,61.57c-.58,0-1.02-.45-1.02-1.03v-13.05l-2.2,2.32c-.17.17-.37.25-.6.25-.45,0-.9-.38-.9-.9,0-.23.08-.45.25-.62l3.52-3.6c.2-.22.5-.32.83-.32.62,0,1.17.48,1.17,1.12v14.8c0,.58-.45,1.03-1.05,1.03Z"
					/>
					<path
						className="cls-2"
						d="m242.93,61.42h-9.97c-.47,0-.95-.42-.95-1,0-.3.12-.57.38-.77,5.85-4.52,9.1-7.45,9.1-10.25,0-2.12-1.75-3.05-3.47-3.05s-3.02.57-4.02,1.55c-.18.17-.4.25-.6.25-.47,0-.95-.4-.95-.92,0-.23.08-.48.25-.65,1.37-1.38,3.27-2.07,5.32-2.07,2.77,0,5.6,1.57,5.6,4.9s-3.45,6.5-8.1,10.17h7.42c.5,0,.9.4.9.9,0,.55-.4.95-.9.95Z"
					/>
					<path
						className="cls-2"
						d="m252.23,61.72c-2.4,0-4.3-.92-5.47-2.2-.17-.17-.25-.38-.25-.6,0-.47.38-.97.88-.97.22,0,.45.1.62.25,1.05,1.05,2.52,1.67,4.17,1.67,2.42,0,3.9-1.2,3.9-3.12,0-2.07-1.7-2.95-4.15-2.95-.75,0-1.88.15-1.88-.95,0-.5.4-.9.9-.9,2.5,0,4.85-.38,4.85-2.75,0-1.85-1.7-2.85-3.72-2.85-1.55,0-2.8.52-3.92,1.52-.15.15-.35.23-.55.23-.42,0-.9-.38-.9-.9,0-.22.1-.47.27-.62,1.3-1.25,3.02-2.07,5.25-2.07,3.2,0,5.65,1.62,5.65,4.45,0,2.4-2.02,3.6-3.6,3.87,1.52.12,3.85,1.42,3.85,4.1s-2.22,4.8-5.9,4.8Z"
					/>
					<path
						className="cls-2"
						d="m271.93,57.19h-1.62v3.35c0,.58-.45,1.03-1.05,1.03s-1.03-.45-1.03-1.03v-3.35h-7.05c-.53,0-1.03-.45-1.03-1.12,0-.23.08-.48.2-.67l6.67-10.02c.32-.48.9-.77,1.5-.77.95,0,1.78.82,1.78,1.75v9.02h1.62c.47,0,.88.4.88.93s-.4.9-.88.9Zm-3.7-10.52l-5.85,8.7h5.85v-8.7Z"
					/>
					<path
						className="cls-2"
						d="m280.98,61.72c-2.42,0-4.12-.75-5.4-2.1-.17-.17-.25-.4-.25-.65,0-.43.35-.97.9-.97.22,0,.47.07.65.25,1.08,1.07,2.38,1.62,4.1,1.62,2.27,0,3.85-1.55,3.85-3.57,0-2.2-1.57-3.6-3.82-3.6-1.25,0-2.47.4-3.45,1.2-.25.2-.55.32-.85.32-.57,0-1.07-.42-1.07-1.02v-6.95c0-.82.67-1.5,1.5-1.5h7.95c.5,0,.9.4.9.95,0,.5-.4.9-.9.9h-7.37v5.8c.8-.8,2.22-1.5,3.9-1.5,2.77,0,5.3,1.9,5.3,5.32s-2.57,5.5-5.92,5.5Z"
					/>
					<path
						className="cls-2"
						d="m295.9,61.72c-4.65,0-6.42-4.07-6.42-8.6s2.1-8.62,6.77-8.62c1.83,0,3.12.52,4.25,1.6.17.17.25.4.25.62,0,.5-.42.92-.92.92-.22,0-.45-.08-.62-.23-.72-.65-1.6-1.07-2.95-1.07-3.22,0-4.7,3.27-4.7,6.55,0,.23,0,.42.02.65.72-1.15,2.57-2.6,4.72-2.6,3,0,5.45,1.77,5.45,5.32,0,2.9-2.2,5.45-5.85,5.45Zm-.1-8.97c-1.65,0-3.25,1.02-4.17,2.5.2,2.07,1.3,4.62,4.2,4.62,2.57,0,3.82-1.92,3.82-3.52,0-2.45-1.7-3.6-3.85-3.6Z"
					/>
				</g>
			</g>
		</svg>
	);
}

export const MemoPlaceholderVinOnly = React.memo(PlaceholderVinOnly);
